
function loadWhenReady() {
    var outputImg = document.getElementById("illustration-img");
    var canvas = document.getElementById("illustration-canvas");
    if (outputImg === null || canvas === null) {
        setTimeout(loadWhenReady, 100);
        return;
    }

    var variants = canvas.getAttribute("data-variants").split(",");
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.onloadend = function () {
        if (xmlHttp.readyState === xmlHttp.DONE && xmlHttp.status === 200) {
            renderCraneArms(xmlHttp.response);
        }
        else {
            console.error(xmlHttp.statusText);
        }

    };

    xmlHttp.open("GET", "/Crane/GetVariants?pids=" + variants.join("&pids="));
    xmlHttp.send();
}

function renderCraneArms(data) {

    var outputImg = document.getElementById("illustration-img");
    var canvas = document.getElementById("illustration-canvas");

    canvas.setAttribute("width", (data.WidestBase + data.WidestJointSum + (data.MostJoints * (5 /* joint gap */ * data.Scaling)) + (40 /* fly-jib indentation */ * data.Scaling) + 10 /* image margin*/) + "px");
    canvas.setAttribute("height", (data.Variants.length * (120 * data.Scaling)) + "px");

    var ctx = canvas.getContext("2d");
    ctx.imageSmoothingEnabled = false;
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    var variants = data.Variants;
    var scale = data.Scaling;


    function drawCraneArms() {

        if (variants.length === 0) {
            canvas.remove();
            outputImg.remove();

            console && console.warn && console.warn("No variants found to render.");
            return;
        }

        var offsetY = 10;
        for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];

            drawArm(variant, offsetY);
            offsetY += 120 * scale;
        }

    }

    var doneTimeOut = 0;
    function doneCallback() {
        clearTimeout(doneTimeOut);
        doneTimeOut = setTimeout(function () {                       
            canvas.toBlob(function (blob) {
                outputImg.src = URL.createObjectURL(blob);
                canvas.remove();
            }, "jpeg");
        }, 200);
    }

    function drawArm(variant_, offsetY) {


        var jointImg = new Image();
        jointImg.crossOrigin = "anonymous";
        jointImg.src = variant_.JointImage;

        var jointManualImg = new Image();
        jointManualImg.crossOrigin = "anonymous";
        jointManualImg.src = variant_.JointManualImage;

        var baseImg = new Image();
        baseImg.crossOrigin = "anonymous";
        /*baseImg.onload =*/ function imagesReady(variant) {

            var isFJ = variant.Name.indexOf("FJ") > -1;

            var offsetX = 10;

            if (isFJ) {
                offsetX = 40 * scale;
                variant.name = variant.Name.split(" ")[1];
            }

            // Set som variables
            var jointGap = 4 * scale;

            var jointWidth = variant.JointWidth;
            var jointHeight = variant.JointHeight;

            var jointManualWidth = variant.JointManualWidth;
            var jointManualHeight = variant.JointManualHeight;

            var nameFontSize = 12 * scale * 0.75;
            var capacityFontSize = 10 * scale * 0.75;


            // Write variant name
            ctx.font = nameFontSize + "px sans-serif";
            var textMeasure = ctx.measureText(variant.Name);

            ctx.fillStyle = "#000000";
            ctx.fillRect(offsetX, offsetY, textMeasure.width + 2, nameFontSize + 2);


            ctx.fillStyle = "#fff";
            ctx.textBaseline = "top";
            ctx.fillText(variant.Name, offsetX + 1, offsetY + 2);

            offsetX += textMeasure.width / 2;
            offsetY += nameFontSize + nameFontSize / 2;


            // Draw the base image
            ctx.drawImage(this, offsetX, offsetY);

            if (variant.BaseImageName.indexOf('flyjib-80-grader.') === 0 || variant.BaseImageName.indexOf('flyjib-0-grader.') === 0) {
                offsetY += 1;
            }

            offsetX += this.width + jointGap;


            // Draw the units/capacity label
            ctx.fillStyle = "#000000";
            ctx.font = capacityFontSize + "px sans-serif";
            ctx.textBaseline = "alphabetic";

            if (variant.CraneBaseAngle !== "") {
                variant.CraneBaseAngle = "(" + variant.CraneBaseAngle + "°) m";
            } else {
                variant.CraneBaseAngle = "m";
            }
            var weightUnit = "kg";

            var unitWidth = ctx.measureText(weightUnit).width;
            var angleWidth = ctx.measureText(variant.CraneBaseAngle).width;

            var aX = offsetX - jointWidth - unitWidth / 2;
            var aY = offsetY + jointHeight * 2 + jointGap * 3;

            ctx.fillText(weightUnit, aX - unitWidth / 2, aY);

            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(aX - unitWidth / 2, aY + 3);
            ctx.lineTo(aX + unitWidth / 2, aY + 3);
            ctx.closePath();
            ctx.stroke();

            ctx.fillText(variant.CraneBaseAngle, aX - angleWidth / 2, aY + 3 + capacityFontSize);



            // Loop to draw each regular joint
            for (var j = 0; j < variant.JointCount - 1; j++) {

                // Draw the joint
                ctx.drawImage(jointImg, offsetX, offsetY);

                // Draw the arrow
                aX = offsetX - jointGap, aY = offsetY + jointHeight + jointGap;
                var bX = offsetX + jointGap, bY = offsetY + jointHeight + jointGap;
                var cX = offsetX, cY = offsetY + jointHeight + (jointGap * 3);

                ctx.beginPath();
                ctx.moveTo(aX, aY);
                ctx.lineTo(bX, bY);
                ctx.lineTo(cX, cY);
                ctx.fill();


                // Draw the capacity for the Joint
                var caps = variant.LiftingCapacities[j];
                if (typeof caps === "undefined") debugger;
                var weightWidth = ctx.measureText(caps.Capacity).width;
                var reachWidth = ctx.measureText(caps.Reach).width;

                ctx.fillText(caps.Capacity, cX - weightWidth / 2, aY + jointHeight + jointGap * 2);

                ctx.lineWidth = 1;
                ctx.beginPath();
                ctx.moveTo(cX - weightWidth / 2, aY + jointHeight + (jointGap * 2) + 3);
                ctx.lineTo(cX + weightWidth / 2, aY + jointHeight + (jointGap * 2) + 3);
                ctx.closePath();
                ctx.stroke();

                ctx.fillText(caps.Reach, cX - reachWidth / 2, aY + jointHeight + (jointGap * 2) + 3 + capacityFontSize);


                offsetX += jointGap + jointWidth;

            }

            aX = offsetX - jointGap, aY = offsetY + jointHeight + jointGap;
            bX = offsetX + jointGap, bY = offsetY + jointHeight + jointGap;
            cX = offsetX, cY = offsetY + jointHeight + (jointGap * 3);

            ctx.beginPath();
            ctx.moveTo(aX, aY);
            ctx.lineTo(bX, bY);
            ctx.lineTo(cX, cY);
            ctx.fill();

            caps = variant.LiftingCapacities[variant.JointCount - 1];
            if (typeof caps === "undefined") debugger;
            weightWidth = ctx.measureText(caps.Capacity).width;
            reachWidth = ctx.measureText(caps.Reach).width;

            ctx.fillText(caps.Capacity, cX - weightWidth / 2, aY + jointHeight + jointGap * 2);

            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(cX - weightWidth / 2, aY + jointHeight + (jointGap * 2) + 3);
            ctx.lineTo(cX + weightWidth / 2, aY + jointHeight + (jointGap * 2) + 3);
            ctx.closePath();
            ctx.stroke();

            ctx.fillText(caps.Reach, cX - reachWidth / 2, aY + jointHeight + (jointGap * 2) + 3 + capacityFontSize);


            ctx.fillStyle = "#878787";
            for (var k = 0; k < variant.JointManualCount; k++) {

                ctx.fillStyle = "#878787";
                //ctx.fillRect(offsetX, offsetY + 1, jointWidth, jointHeight - 3);
                ctx.drawImage(jointManualImg, offsetX, offsetY);

                offsetX += jointGap + jointManualWidth;

                aX = offsetX - jointGap + 0.6, aY = offsetY + jointManualHeight + jointGap + 0.5;
                bX = offsetX + jointGap - 0.6, bY = offsetY + jointManualHeight + jointGap + 0.5;
                cX = offsetX, cY = offsetY + jointManualHeight + (jointGap * 3) - 0.5;


                ctx.beginPath();
                ctx.moveTo(aX, aY);
                ctx.lineTo(bX, bY);
                ctx.lineTo(cX, cY);
                ctx.closePath();
                ctx.stroke();


                caps = variant.LiftingCapacities[variant.JointCount + k];
                if (typeof caps === "undefined") debugger;
                weightWidth = ctx.measureText(caps.Capacity).width;
                reachWidth = ctx.measureText(caps.Reach).width;

                ctx.fillStyle = "#000";

                ctx.fillText(caps.Capacity, cX - weightWidth / 2, aY + jointManualHeight + (jointGap * 2) - 0.5);

                ctx.lineWidth = 1;
                ctx.beginPath();
                ctx.moveTo(cX - weightWidth / 2, aY + jointManualHeight + (jointGap * 2) + 2.5);
                ctx.lineTo(cX + weightWidth / 2, aY + jointManualHeight + (jointGap * 2) + 2.5);
                ctx.closePath();
                ctx.stroke();

                ctx.fillText(caps.Reach, cX - reachWidth / 2, aY + jointManualHeight + (jointGap * 2) + 2.5 + capacityFontSize);

            }


            doneCallback();

        }

        //setTimeout(function () {
        baseImg.src = variant_.BaseImage;
        var imagesReadyP = Promise.all([baseImg.decode(), jointImg.decode(), jointManualImg.decode()]);
        imagesReadyP.then(imagesReady.bind(baseImg, variant_)).catch(console.error);
        //}, 1000);
    }

    drawCraneArms();
}

loadWhenReady();